import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';

export interface RewardsHistoryRow {
  orderId: number;
  invoiceNumber: string;
  date: string;
  amount: number;
  pointsEarned: number;
}

export interface RewardsSummary {
  points: number;
  tier: 'BRONZE' | 'SILVER' | 'GOLD';
  redeemableValue: number;
  pointsToNextTier: number;
  nextTierThreshold: number;
  currentTierFloor: number;
  takaPerPoint: number;
  pointValueTaka: number;
  ordersCompleted: number;
  history: RewardsHistoryRow[];
  error?: string;
}

@Injectable({
  providedIn: 'root'
})
export class RewardsService {

  baseUrl = 'https://superbangladesh-api-1.onrender.com/api/rewards';

  constructor(private http: HttpClient) {}

  private readonly KEY = 'sb_rewards_v1';

  private tokenTail(): string | null {

    if (typeof localStorage === 'undefined') {
      return null;
    }

    const t = localStorage.getItem('token');

    return t ? t.slice(-16) : null;
  }

  // শেষবার পাওয়া রিওয়ার্ড (একই লগইনের) — পেজ খোলার সাথে সাথে দেখানোর জন্য
  peek(): RewardsSummary | null {

    try {

      const tail = this.tokenTail();

      if (!tail) {
        return null;
      }

      const raw = localStorage.getItem(this.KEY);

      if (!raw) {
        return null;
      }

      const o = JSON.parse(raw);

      return o && o.t === tail && o.data ? o.data : null;

    } catch {
      return null;
    }
  }

  private save(data: RewardsSummary): void {

    try {

      const tail = this.tokenTail();

      if (tail) {
        localStorage.setItem(this.KEY, JSON.stringify({ t: tail, data }));
      }

    } catch {
      // ignore
    }
  }

  // লগইন থাকলে আগেভাগে চুপচাপ এনে রাখে
  prefetch(): void {

    if (!this.tokenTail()) {
      return;
    }

    this.getMyRewards().subscribe({ error: () => {} });
  }

  getMyRewards() {

    const token =
      typeof localStorage !== 'undefined'
        ? localStorage.getItem('token')
        : null;

    return this.http.get<RewardsSummary>(
      this.baseUrl + '/me',
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    ).pipe(
      tap(res => {
        if (res && !res.error) {
          this.save(res);
        }
      })
    );
  }
}
